import React, { useMemo, useState } from "react";
import TabellaLista from "../../../../components/Tabella/TabellaLista";
import { ChipFilter, filtroMultiplo } from "../../../../components/Tabella/ChipFilter";

const data_column = [

	{
		Header: 'Nome prodotto',
		accessor: 'prodotto_nome',
	},
	{
		Header: 'Prezzo',
		accessor: 'prodotto_prezzo',
		disableGlobalFilter: true,
	},
	{
		Header: 'Prezzo ai soci',
		accessor: 'prodotto_soci',
		disableGlobalFilter: true,
	},

	{
		Header: 'Visibilità',
		accessor: 'prodotto_vis',
		disableGlobalFilter: true,
		Cell: ({ value }) => {
			return (
				<div className="d-flex align-items-center">
					<i className={`fa fa-circle me-1 ${value.class}`}></i>
					{value.label}
				</div>
			)
		},
		disableFilters: true,
	},
	{
		Header: 'Stato',
		accessor: 'prodotto_status',
		disableGlobalFilter: true,
		Cell: ({ value }) => {
			return (
				<div className="d-flex align-items-center">
					<i className={`fa fa-circle me-1 ${value.class}`}></i>
					{value.label}
				</div>
			)
		},
		disableFilters: true,
	},
];
const data_json = [

	{
		"prodotto_nome": "Abbonamento mensile Tennis",
		"prodotto_prezzo": "€ 99,00/Mese",
		"prodotto_soci": "€ 89,00/Mese",
		"prodotto_status": {
			"label": "Attivo",
			"class": "text-success"
		},
        "prodotto_vis": {
			"label": "Pubblico",
			"class": "text-success"
		},
	},
    {
		"prodotto_nome": "Affitto campo tennis",
		"prodotto_prezzo": "€ 9,00/Ora",
		"prodotto_soci": "€ 8,00/Ora",
		"prodotto_status": {
			"label": "Bozza",
			"class": "text-primary"
		},
        "prodotto_vis": {
			"label": "Privato",
			"class": "text-danger"
		},
	}
	
];

// Valori dei filtri a chip, come compaiono nella lista.
const VISIBILITA_OPTIONS = ['Pubblico', 'Privato'];
const STATO_OPTIONS = ['Attivo', 'Bozza'];

const ListaProdotti = () => {
	const [visibilitaFilter, setVisibilitaFilter] = useState(VISIBILITA_OPTIONS);
	const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);

	const filteredData = useMemo(
		() =>
			data_json.filter(
				(row) =>
					filtroMultiplo(visibilitaFilter, VISIBILITA_OPTIONS, row.prodotto_vis?.label) &&
					filtroMultiplo(statoFilter, STATO_OPTIONS, row.prodotto_status?.label),
			),
		[visibilitaFilter, statoFilter],
	);

	return (
		<TabellaLista
			pageList={true}
			cardTitle={'Prodotti'}
			hasSearch={true}
			searchPlaceholder={'Cerca per nome prodotto'}
			hasFilter={false}
			filterControl={
				<div className="sid-chip-filters">
					<ChipFilter label="Visibilità" options={VISIBILITA_OPTIONS} value={visibilitaFilter} onChange={setVisibilitaFilter} multiple />
					<ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
				</div>
			}
			hasAddMore={true}
			labelAddMore={'Nuovo prodotto'}
			linkAddMore={'/struttura/prodotti/lista/aggiungi'}
			data_column={data_column}
			data_json={filteredData}
		/>
	)
}

export default ListaProdotti
